/**
 * List Schema of TypeWebhook
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {TypeWebhook} from '@/model/resource/TypeWebhook'

/* TODO: review generated schema */
export class ListTypeWebhookSchema extends Schema {
  readonly name = 'ListTypeWebhook'

  readonly fieldSet: FieldSet<TypeWebhook> = {
    idTypePk: (): FieldComponent => ({
      is: Component.Render,
    }),
    nome: (): FieldComponent => ({
      is: Component.Render,
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.ativo),
      },
    }),
  }
}
